<template>
  <svg :width="svgWidth" :height="svgHeight" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 21.25H7C3.35 21.25 1.25 19.15 1.25 15.5V8.5C1.25 4.85 3.35 2.75 7 2.75H17
      C20.65 2.75 22.75 4.85 22.75 8.5V15.5C22.75 19.15 20.65 21.25 17 21.25ZM7 4.25
      C4.14 4.25 2.75 5.64 2.75 8.5V15.5C2.75 18.36 4.14 19.75 7 19.75H17
      C19.86 19.75 21.25 18.36 21.25 15.5V8.5C21.25 5.64 19.86 4.25 17 4.25H7Z"
      :fill="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true"
      @mouseout="isHover = false"
    />
    <path
      d="M11.9988 12.87C11.1588 12.87 10.3088 12.61 9.6588 12.08
      L6.5288 9.57997C6.2088 9.31997 6.14881 8.84997 6.4088 8.52997
      C6.6688 8.20997 7.13881 8.14997 7.45881 8.40997L10.5888 10.91
      C11.3488 11.52 12.6388 11.52 13.3988 10.91L16.5288 8.40997
      C16.8488 8.14997 17.3288 8.19997 17.5788 8.52997
      C17.8388 8.84997 17.7888 9.32997 17.4588 9.57997
      L14.3288 12.08C13.6888 12.61 12.8388 12.87 11.9988 12.87Z"
      :fill="color ? color : theme === 'light' ? '#292D32' : '#fff'"
      @mouseover="isHover = true"
      @mouseout="isHover = false"
    />
  </svg>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    width: {
      type: String,
      default: '20',
    },
    height: {
      type: String,
      default: '20',
    },
    color: {
      type: String,
    },
  },
  data() {
    return {
      isHover: false,
    };
  },
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
    svgWidth() {
      return this.width;
    },
    svgHeight() {
      return this.height;
    },
  },
};
</script>
